module.exports = __webpack_public_path__ + "static/media/90.70d6435f.gif";